class WishlistStore {
  constructor() {
    this.storageKey = 'shopify-wishlist';
    this.isAvailable = this.checkStorageAvailable();
  }
  
  checkStorageAvailable() {
    try {
      const storage = window.localStorage;
      const testKey = '__storage_test__';
      storage.setItem(testKey, testKey);
      storage.removeItem(testKey);
      return true;
    } catch (e) {
      console.warn('localStorage is not available:', e);
      return false;
    }
  }

  getWishlist() {
    if (!this.isAvailable) return [];
    
    try {
      const wishlist = window.localStorage.getItem(this.storageKey);
      console.log(wishlist)
      return wishlist ? JSON.parse(wishlist) : [];
    } catch (e) {
      console.error('Error getting wishlist:', e);
      return [];
    }
  }

  addToWishlist(productId) {
    if (!this.isAvailable) return false;
    
    try {
      const wishlist = this.getWishlist();
      if (!wishlist.includes(productId)) {
        wishlist.push(productId);
        window.localStorage.setItem(this.storageKey, JSON.stringify(wishlist));
        this.triggerEvent('wishlist:added', { productId });
        return true;
      }
      return false;
    } catch (e) {
      console.error('Error adding to wishlist:', e);
      return false;
    }
  }

  removeFromWishlist(productId) {
    if (!this.isAvailable) return false;
    
    try {
      const wishlist = this.getWishlist();
      const index = wishlist.indexOf(productId);
      
      if (index > -1) {
        wishlist.splice(index, 1);
        window.localStorage.setItem(this.storageKey, JSON.stringify(wishlist));
        this.triggerEvent('wishlist:removed', { productId });
        return true;
      }
      return false;
    } catch (e) {
      console.error('Error removing from wishlist:', e);
      return false;
    }
  }

  isInWishlist(productId) {
    if (!this.isAvailable) return false;
    
    try {
      const wishlist = this.getWishlist();
      return wishlist.includes(productId);
    } catch (e) {
      console.error('Error checking wishlist:', e);
      return false;
    }
  }

  clearWishlist() {
    if (!this.isAvailable) return false;
    
    try {
      window.localStorage.removeItem(this.storageKey);
      this.triggerEvent('wishlist:cleared');
      return true;
    } catch (e) {
      console.error('Error clearing wishlist:', e);
      return false;
    }
  }

  triggerEvent(eventName, data = {}) {
    const event = new CustomEvent(eventName, {
      detail: data,
      bubbles: true
    });
    document.dispatchEvent(event);
  }
}

const wishlistStore = new WishlistStore();
